import { AxiosConfig, AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { useStorage } from '@/hooks/web/useStorage'
import { useRoute, useRouter } from 'vue-router'
import { getQueryParam } from '@/utils/tools.js'
import { delUrlCode } from '@/utils/wxTool.ts'

const route = useRoute()
const router = useRouter()
const { removeStorage } = useStorage('localStorage')
const { getStorage } = useStorage()

const config: AxiosConfig = {
  pointBaseUrl: import.meta.env.VITE_POINT_URL,
  /**
   * api请求基础路径
   */
  baseUrl: import.meta.env.VITE_BASE_URL,
  // baseUrl: {
  //   // 开发环境接口前缀
  //   base: 'http://192.168.3.43:8860',

  //   // 打包开发环境接口前缀
  //   dev: 'http://online-console-api.miclass.net',

  //   // 打包生产环境接口前缀
  //   pro: '',

  //   // 打包测试环境接口前缀
  //   test: 'http://online-console-api.miclass.net'
  // },

  /**
   * 接口成功返回状态码
   */
  code: 200,

  /**
   * 接口请求超时时间
   */
  timeout: 60000,

  /**
   * 默认接口请求类型
   * 可选值：application/x-www-form-urlencoded multipart/form-data
   */
  defaultHeaders: 'application/json',

  interceptors: {
    // 请求拦截
    // requestInterceptors: (config) => {
    //   return config
    // },
    // 响应拦截器
    // responseInterceptors: (result: AxiosResponse) => {
    //   return result
    // }
  }
}

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    (config.headers as AxiosRequestHeaders)['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse<any>) => {
  console.log('请求', response)
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.code === 1006) {
    window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/6`
  } else if (
    response.data.code === config.code ||
    response.data.code === 400 ||
    response.data.code === 1004 ||
    response.data.code === 1005 ||
    response.data.code === 1100 ||
    response.data.code === 1101 ||
    response.data.code === 1003 ||
    response.data.code === 1009 ||
    response.data.code === 1010 ||
    response.data.code === 1102
  ) {
    return response.data
    /*  }else if(response.data.code === 1006){
    window.location.href = `${window.location.protocol}//${window.location.hostname}/nopremission/6` */
  } else if (response.data.code === 1008) {
    // 报名观看
    removeStorage('loginInfo_' + getStorage('roomId'))
    setTimeout(() => {
      window.location.reload()
    }, 2000)
    return
  } else if (response.data.code === 1106) {
    // userLoginByBuyRoomIdApi 自动登录接口登录失败
    delUrlCode()
    window.location.reload()
  } else {
    /* if(response?.data?.code == 400){
      console.log('response?.data',response?.data)
      response?.data
    } */
    if (response?.data?.code != 402 && response?.config.url != '/reportErrorLog') {
      ElMessage.error(response?.data?.msg)
    }
    if (response?.data?.msg == '微信授权失败') {
      console.log('ccc3', window.location.host + '/' + route.params.id)
      window.location.href = window.location.protocol + '//' + window.location.host + '/' + route.params.id
      return
    }
    if (response?.data?.code == 401) {
      // token过期
      // clear()
      if (window.location.href.includes('/personal/')) {
        console.log('personal3', route)
        console.log('personal1', getQueryParam('type'))
        const _arr: any = window.location.href.split('/')
        let id: any = _arr[_arr.length - 1]
        if (getQueryParam('type')) {
          id = id.split('&')[0]
          window.location.href = window.location.protocol + '//' + window.location.host + '/commodity/' + id
        } else {
          window.location.href = window.location.protocol + '//' + window.location.host + '/' + id
        }
        return
      }
      if (/\/commodity\/|\/coupon\//.test(window.location.href)) {
        removeStorage('loginInfo_' + useStorage('sessionStorage').getStorage('clientId'))
      } else if (/\/column\//.test(window.location.href)) {
        removeStorage('loginInfo_' + useStorage('sessionStorage').getStorage('columnId'))
      } else {
        removeStorage('loginInfo_' + getStorage('roomId'))
      }
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
export default config
